
export default class MemberBankAccountResponseModel {
    public bankAccountId: number = 0;
    public bankAccountName: string = '';
    public balance: number = 0;
    public confirmed: boolean = false;
    public createdBy: string = '';
}
